import { MeasurementsButton } from 'feature/measurements/MeasurementsButton'
import { needMeasurements } from 'feature/measurements/util'
import { ClothingSizes } from 'feature/sizes/ClothingSizes/ClothingSizes'
import { observer } from 'mobx-react-lite'
import { InferenceStore } from 'store/inference/InferenceStore'
import { opt } from 'store/opt'

type Props = {
  inference: InferenceStore
}

export const InferenceSizes = observer(({ inference }: Props) => {
  const measure = opt.sizes && needMeasurements(inference)

  if (measure) return <MeasurementsButton inference={inference} profile={measure} />

  return <ClothingSizes inference={inference} />
})
